/* ============================================================================
   tne-account.js — Toggle login ↔ recover password
   DistribuidorTopBioEuropa | Site institucional B2B

   Comportamento:
     - Estado inicial mostra view "login"
     - Click em link com [data-tne-login-show] alterna para a view indicada
     - Se URL já vem com #recover ou #login, mostra a view correspondente
     - Mantém o hash actualizado para preservar estado em refresh
   ============================================================================ */

(function () {
  'use strict';

  function init() {
    const root = document.querySelector('[data-tne-login]');
    if (!root) return;

    const views = root.querySelectorAll('[data-tne-login-view]');
    if (!views.length) return;

    function showView(name) {
      let matched = false;
      views.forEach(function (view) {
        const isMatch = view.getAttribute('data-tne-login-view') === name;
        if (isMatch) {
          view.removeAttribute('hidden');
          matched = true;
          // Foco no primeiro input visível para acessibilidade.
          const firstInput = view.querySelector(
            'input[type="email"], input[type="password"]'
          );
          if (firstInput && document.activeElement === document.body) {
            // Atraso leve para evitar conflito com scroll-to-hash do browser.
            window.setTimeout(function () {
              firstInput.focus({ preventScroll: true });
            }, 50);
          }
        } else {
          view.setAttribute('hidden', '');
        }
      });
      return matched;
    }

    // Toggle handlers (botões/links com data-tne-login-show).
    root.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-tne-login-show]');
      if (!trigger || !root.contains(trigger)) return;

      const target = trigger.getAttribute('data-tne-login-show');
      if (!target) return;

      event.preventDefault();
      if (showView(target)) {
        // Sincroniza o hash sem provocar scroll.
        if (history.replaceState) {
          history.replaceState(null, '', '#' + target);
        } else {
          window.location.hash = target;
        }
      }
    });

    // Estado inicial baseado no hash.
    function applyHash() {
      const hash = (window.location.hash || '').replace('#', '').toLowerCase();
      if (hash === 'recover' || hash === 'login') {
        showView(hash);
      }
    }

    applyHash();
    window.addEventListener('hashchange', applyHash);

    // Se houve sucesso na recuperação (Shopify mostra mensagem dentro de
    // #recover), a página vem com a view login visível por defeito mas o
    // bloco de sucesso está dentro de #recover. Forçamos mostrar #recover
    // se ele tiver a classe de sucesso renderizada pelo Shopify.
    const recoverView = root.querySelector('[data-tne-login-view="recover"]');
    if (recoverView && recoverView.querySelector('.tne-recover__success')) {
      showView('recover');
      if (history.replaceState) {
        history.replaceState(null, '', '#recover');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
